// Project picker + per-project chat landing copy — the PickerPage, the
// SessionSidebar (session list, rename/delete menu), and the ResumeBanner.
// Keys: projects.<key>.

import type { MsgSection } from "./types.js";

export const projects: MsgSection = {
  // PickerPage
  "projects.pickTitle": { en: "Pick a project", de: "Projekt auswählen" },
  "projects.openSessionFailed": {
    en: "Failed to open session: {error}",
    de: "Sitzung liess sich nicht öffnen: {error}",
  },
  "projects.filterAriaLabel": { en: "Filter projects", de: "Projekte filtern" },
  "projects.filterPlaceholder": { en: "Filter projects…", de: "Projekte filtern…" },
  "projects.loadingProjects": { en: "Loading projects…", de: "Projekte werden geladen…" },
  "projects.loadProjectsFailed": {
    en: "Couldn't load projects: {error}",
    de: "Projekte liessen sich nicht laden: {error}",
  },
  "projects.noProjectsMatch": {
    en: "No projects match the current filter.",
    de: "Kein Projekt passt zum Filter.",
  },
  "projects.lastActivity": { en: "Last activity {when}", de: "Letzte Aktivität {when}" },
  "projects.open": { en: "Open", de: "Öffnen" },

  // ProjectChatPage
  "projects.startFailed": {
    en: "Failed to start: {error}",
    de: "Start fehlgeschlagen: {error}",
  },
  "projects.startNewHeading": { en: "Start a new session", de: "Neue Sitzung starten" },
  "projects.startNewSubtitle": {
    en: "Or pick a prior session from the sidebar.",
    de: "Oder nimm eine frühere Sitzung aus der Seitenleiste.",
  },
  "projects.starting": { en: "Starting…", de: "Wird gestartet…" },
  "projects.startSession": { en: "Start session", de: "Sitzung starten" },
  "projects.switchProject": { en: "Switch project", de: "Projekt wechseln" },

  // ResumeBanner
  "projects.resume": { en: "Resume", de: "Fortsetzen" },

  // SessionSidebar
  "projects.sessionTitleAriaLabel": { en: "Session title", de: "Sitzungstitel" },
  "projects.sessionOptionsAriaLabel": { en: "Session options", de: "Sitzungsoptionen" },
  "projects.rename": { en: "Rename", de: "Umbenennen" },
  "projects.delete": { en: "Delete", de: "Löschen" },
  "projects.thisProject": { en: "This project", de: "Dieses Projekt" },
  "projects.recentSessions": { en: "Recent sessions", de: "Letzte Sitzungen" },
  "projects.newSession": { en: "+ New", de: "+ Neu" },
  "projects.loadSessionsFailed": {
    en: "Failed to load: {error}",
    de: "Laden ging schief: {error}",
  },
  "projects.noSessionsYet": { en: "No sessions yet.", de: "Noch keine Sitzungen." },
  "projects.liveBadge": { en: "live", de: "live" },
};
